import { render, staticRenderFns } from "./NewTasks.vue?vue&type=template&id=085e3a55&scoped=true"
import script from "./NewTasks.vue?vue&type=script&lang=js"
export * from "./NewTasks.vue?vue&type=script&lang=js"
import style0 from "./NewTasks.vue?vue&type=style&index=0&id=085e3a55&lang=less&scoped=true"
import style1 from "./NewTasks.vue?vue&type=style&index=1&id=085e3a55&lang=less&scoped=true"
import style2 from "./NewTasks.vue?vue&type=style&index=2&id=085e3a55&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085e3a55",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('085e3a55')) {
      api.createRecord('085e3a55', component.options)
    } else {
      api.reload('085e3a55', component.options)
    }
    module.hot.accept("./NewTasks.vue?vue&type=template&id=085e3a55&scoped=true", function () {
      api.rerender('085e3a55', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/P1_Girls/HostessTasks/components/NewTasks.vue"
export default component.exports